import momentLocalTimezone from './momentLocalTimezone';

// eslint-disable-next-line import/prefer-default-export
export const isOlderThan72BusinessHours = async dateToCheck => {
  const { default: Holidays } = await import('date-holidays');
  const startDate = new Date(dateToCheck);
  const holidays = new Holidays('MX');
  const today = new Date();
  startDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  let businessDayCount = 0;

  for (
    let currentDate = new Date(startDate);
    currentDate < today;
    currentDate.setDate(currentDate.getDate() + 1)
  ) {
    const dayOfWeek = momentLocalTimezone().isoWeekday();
    const isHoliday = holidays.isHoliday(currentDate);

    if (dayOfWeek && !isHoliday) businessDayCount++;
    if (businessDayCount > 3) return true;
  }

  return false;
};
